module.exports = __webpack_public_path__ + "media/images/editar-1543803f28c4fb4189485ced64c3768d.svg";